<template>
  <div class="modal-wrapper">
    <modal-header :title="title" :subtitle="subtitle" :on-modal-close="close" />
    <div class="homebase-modal-body pb-5 px-5">
      <div v-if="isLoading"><modal-loading /></div>
      <div v-else>
        <div v-if="isSuccess">
          <modal-success
            :description="successMsg"
          />
        </div>
        <div v-else class="row">
          <div class="col-12 pb-3">
            <div class="alert alert-error" v-if="isErrored">
              {{ CONSTANTS.SERVER_ERROR_MESSAGE }}
            </div>
          </div>
          <div class="col-6">
            <div class="pb-3" v-for="(inputGroupData, i) in groupsColumn1" :key="i">
              <edit-interests-input-group
                ref="inputGroupRef"
                :title="inputGroupData.title"
                :loaded-inputs="inputGroupData.inputs"
                :column-class="'col-12'"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="pb-3" v-for="(inputGroupData, i) in groupsColumn2" :key="i">
              <edit-interests-input-group
                ref="inputGroupRef"
                :title="inputGroupData.title"
                :loaded-inputs="inputGroupData.inputs"
                :column-class="'col-12'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isLoading"
      class="
        d-flex
        flex-column flex-sm-row
        justify-content-end
        homebase-modal-footer
        px-5
        pb-5
      "
    >
      <div
        v-if="!isSuccess"
        class="homebase-btn-secondary mt-2 ml-sm-4"
        @click="close"
      >
        Cancel
      </div>
      <div
        v-if="!isSuccess"
        class="homebase-btn-primary mt-2 ml-sm-4"
        @click="save"
      >
        Save
      </div>
      <div
        v-if="isSuccess"
        class="homebase-btn-primary mt-2 ml-sm-4"
        @click="close"
      >
        Done
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";
import EditInterestsInputGroup from "./EditInterestsInputGroup";
import ModalHeader from "../modals/ModalHeader";
import ModalLoading from "../modals/ModalLoading";
import ModalSuccess from "../modals/ModalSuccess";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "edit-interests-modal",
  props: ["topics"],
  mixins: [HomebaseMixpanelMixin],
  components: {
    EditInterestsInputGroup,
    ModalLoading,
    ModalHeader,
    ModalSuccess,
  },
  data() {
    return {
      CONSTANTS,
      isLoading: false,
      isErrored: false,
      isSuccess: false,
      title: "",
      subtitle: "",
      successMsg: "Your interests have been saved.",
      inputGroups: null,

      //Layout
      groupsColumn1: [],
      groupsColumn2: [],
    };
  },
  created() {
    this.initializeModal();
  },
  methods: {

    initializeModal() {
      this.setDefaultHeaderConfig();
      this.setInputGroups();
    },

    setDefaultHeaderConfig() {
      this.title = "News based on your interests";
      this.subtitle =
        "Start curating your news based on what you are interested in";
    },

    setSavingHeaderConfig() {
      this.title = "Saving your interests...";
      this.subtitle = null;
    },


    close() {
      this.$emit("update:modelValue", false);
    },

    setInputGroups() {
      this.inputGroups = this.getInputGroups();
    },

    getInputGroups() {
      if (!this.topics || this.topics.length === 0) return [];

      let categoryToTopics = this.topics.reduce((map, topic) => {
        map[topic.category] = [...(map[topic.category] || []), topic];
        return map;
      }, {});

      let result = [];
      for (const [category, topics] of Object.entries(categoryToTopics)) {
        result.push({
          title: category,
          inputs: topics,
        });
      }

      this.groupData(result);

      return result;
    },

    groupData(data) {
      let column1Space = 0;
      let column2Space = 0;
      let headerSpace = 1; // Each header counts as one topic's worth of space
      
      // Sort the items by inputs lenght to determine space
      data.sort((a, b) => b.inputs.length - a.inputs.length);

      // Determine which column to add the group to
      data.forEach((group) => {
        if (column1Space <= column2Space) {
          this.groupsColumn1.push(group);
          column1Space += group.inputs.length + headerSpace;
        } else {
          this.groupsColumn2.push(group);
          column2Space += group.inputs.length + headerSpace;
        }
      });
    },

    processSelections() {
      let result = [];
      let inputGroups = this.$refs.inputGroupRef;

      inputGroups.forEach((group) => {
        let formattedSelections = group.processSelections();
        result = result.concat(formattedSelections);
      });

      return result;
    },

    async save() {
      this.isLoading = true;
      this.setSavingHeaderConfig();
      let selections = this.processSelections();
      let formattedSelections = this.formatSelections(selections);

      try {
        let res = await api.updateNewsTopicSubscriptions(formattedSelections);
        if (res.data.data.subscribeToTopics.error) {
          throw "Error";
        } else {
          this.isSuccess = true;
          this.$parent.$emit("interestsSaved");
          this.setDefaultHeaderConfig();
        }

      } catch (e) {
        this.isErrored = true;
      }

      this.isLoading = false;
    },

    formatSelections(selections) {
      return selections.map((s) => {
        return {
          id: s.id,
          subscribe: s.subscribe,
        };
      });
    },
  },
};
</script>

<style scoped>
.modal-wrapper {
  position: relative;
}
.homebase-modal-body {
  padding-top: 34px;
  min-height: 300px;
}
</style>
